module.exports = __webpack_public_path__ + "media/images/home_logo-5f9994f51e723f5f9799896348c80f57.png";